(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["approach-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.tabs-section');
  if (!section) return;
  var bar    = section.querySelector('.tabs-bar');
  var btns   = section.querySelectorAll('.tab-btn');
  var panels = section.querySelectorAll('.tab-panel');
  var kicks  = section.querySelectorAll('.rail-kicker__text');

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx = parseInt(btn.dataset.tab, 10);

      btns.forEach(function(b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      panels.forEach(function(p, i) {
        p.classList.toggle('is-active', i === idx);
      });

      if (bar) bar.classList.add('is-switching');
      kicks.forEach(function(k) { k.classList.remove('is-active'); });
      setTimeout(function() {
        kicks.forEach(function(k, i) { k.classList.toggle('is-active', i === idx); });
        if (bar) bar.classList.remove('is-switching');
      }, 170);
    });
  });

  /* Read more folds */
  section.querySelectorAll('.tp-readmore').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var fold = btn.previousElementSibling;
      if (!fold || !fold.classList.contains('tp-more')) return;
      var open = fold.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.childNodes[0].nodeValue = open ? 'Read less ' : 'Read more ';
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var root, itemsEl, totalEl, countEl;

  /* units added per press of the buy button, per plan. MUST stay in sync with
     PLANS in assets/tessera-cart-bridge.js - 90-day ships 3 tubs, monthly 1.
     /cart.js returns selling_plan.id as a bare number, so these numeric keys
     (stored as strings, as all JS object keys are) match on lookup. */
  var PLAN_PACK = { 724415742283: 3, 724393361739: 1 };

  /* 2026-09-02 (Wander): NEW to this file - mirrors the busy flag in
     assets/tessera-cart-bridge.js. One cart write in flight at a time, so a
     double-click on a stepper cannot queue two changes against a stale
     quantity. The pressed control is disabled for the same window. */
  var busy = false;

  function money(c) {
    try {
      return (c / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) { return '$' + (c / 100).toFixed(2); }
  }

  /* quiet=true suppresses the insertion cascade - see .tcd--nodeal above. */
  function render(cart, quiet) {
    if (!itemsEl) return;
    if (root && quiet) { root.classList.add('tcd--nodeal'); }
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="tcd__dempty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        var variant = it.product_has_only_default_variant ? '' : '<div class="tcd__li-v">' + it.variant_title + '</div>';
        /* 2026-09-02 (Wander): selling plan name, plus a bracketed pack count.
           Shopify MERGES repeat adds of the same variant+plan into one line and
           sums the quantity - two presses of the 90-day button is a single line
           at Qty 6, not two lines - so the number of packs is derived from the
           quantity here rather than tracked anywhere. Only shown when the pack
           size divides the quantity exactly and comes to 2 or more: an edited
           quantity (Qty 4 on a 3-tub plan, only reachable from the cart page's
           stepper) renders the bare plan name rather than a rounded or
           fractional count. Name is not escaped - same as product_title and
           variant_title above; the count is computed, so it is safe. */
        var plan = '';
        var pack = 1;
        if (it.selling_plan_allocation) {
          pack = PLAN_PACK[it.selling_plan_allocation.selling_plan.id] || 1;
          var packs = (pack > 0 && it.quantity % pack === 0) ? (it.quantity / pack) : 0;
          /* 2026-09-03 (Wander): "Subscription" appended to the plan name so the
             line item reads as a recurring charge, not a one-off delivery cadence
             - same disclosure concern as the "Refuel" wording note in
             snippets/tlp-offer.liquid. Guarded with a case-insensitive check so
             the 30-Day plan's real Appstle name, "Monthly Subscription", does not
             come out "Monthly Subscription Subscription" - the 90-Day plan's name,
             "90 day supply", has no such word and gets it appended plainly. */
          var planName = it.selling_plan_allocation.selling_plan.name;
          if (!/subscription/i.test(planName)) { planName += ' Subscription'; }
          plan = '<div class="tcd__li-plan">' + planName +
                 (packs > 1 ? ' (' + packs + ')' : '') + '</div>';
        }
        /* 2026-09-02 (Wander): stepper. The pack size rides on the element so the
           click handler needs no second lookup, and the line is addressed by key
           rather than by line index, which shifts when a line is removed. */
        var stepper =
          '<div class="tcd__li-qty" data-tcd-key="' + it.key + '" data-tcd-qty="' + it.quantity + '" data-tcd-pack="' + pack + '">' +
            '<button type="button" class="tcd__qbtn" data-tcd-step="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<span class="tcd__qval">' + it.quantity + '</span>' +
            '<button type="button" class="tcd__qbtn" data-tcd-step="1" aria-label="Increase quantity">&plus;</button>' +
          '</div>';
        return '<div class="tcd__li">' +
          '<div class="tcd__li-img">' + img + '</div>' +
          '<div class="tcd__li-b">' +
            '<h4 class="tcd__li-t">' + it.product_title + '</h4>' + variant +
            '<div class="tcd__li-v">Qty ' + it.quantity + '</div>' +
            plan +
            stepper +
            '<div class="tcd__li-p">' + money(it.final_line_price) + '</div>' +
          '</div>' +
          '<button class="tcd__li-x" data-tcd-remove="' + it.key + '" aria-label="Remove">&times;</button>' +
        '</div>';
      }).join('');
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (countEl) countEl.textContent = 'Subtotal (' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  /* 2026-09-02 (Wander): body.tcd-open is set alongside the existing inline
     scroll lock and released on the same line, so it cannot outlive the drawer.
     close() is the ONLY place .is-open is removed (close button, scrim, Escape
     and every programmatic path all route through it), so this one pair covers
     every close. It matches the body.tcd-folded convention snippets/cart-open.liquid
     already uses, and drives the .foot-news hide in the stylesheet above.
     open() also clears .tcd--nodeal so opening the drawer still deals the cards. */
  function open() { if (root) { root.classList.remove('tcd--nodeal'); root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.classList.add('tcd-open'); document.body.style.overflow = 'hidden'; refresh(); } }
  function close() { if (root) { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.classList.remove('tcd-open'); document.body.style.overflow = ''; } }

  /* 2026-09-02 (Wander): stepper writes. /cart/change.js returns the updated
     cart, so the response is rendered directly rather than costing a second
     /cart.js round trip. Rendering the whole cart is what keeps the (N) pack
     bracket, the plan name, the line price and the subtotal in step. */
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart, true); })
      .catch(function () { return refresh(); })
      .then(function () { busy = false; });
  }

  /* 2026-09-02 (Wander): optional third argument is a selling plan id. It goes
     on the item only when truthy - never as null or "". The upsell buttons
     ([data-tcd-add]) still call this with two arguments and are unaffected. */
  function addVariant(id, qty, plan) {
    var item = { id: id, quantity: qty || 1 };
    if (plan) { item.selling_plan = Number(plan); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function () { return refresh(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    root    = document.getElementById('tcd');
    itemsEl = document.getElementById('tcdItems');
    totalEl = document.getElementById('tcdTotal');
    countEl = document.getElementById('tcdCount');
    if (!root) return;

    var closeBtn = document.getElementById('tcdClose');
    var scrim    = document.getElementById('tcdScrim');
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim)    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-tcd-add]');
      if (add) {
        e.preventDefault();
        var label = add.textContent;
        add.disabled = true; add.textContent = 'Adding...';
        addVariant(add.getAttribute('data-tcd-add'), 1).then(function () {
          add.disabled = false; add.textContent = label; open();
        });
        return;
      }

      var rm = e.target.closest('[data-tcd-remove]');
      if (rm) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: rm.getAttribute('data-tcd-remove'), quantity: 0 })
        }).then(refresh);
        return;
      }

      var step = e.target.closest('[data-tcd-step]');
      if (step) {
        e.preventDefault();
        if (busy) { return; }
        var cell = step.closest('[data-tcd-key]');
        if (!cell) { return; }
        var qty  = parseInt(cell.getAttribute('data-tcd-qty'), 10) || 0;
        var pack = parseInt(cell.getAttribute('data-tcd-pack'), 10) || 1;
        if (pack < 1) { pack = 1; }
        /* Both directions move to a valid multiple of the pack, so a line left
           at 7 on a 3-tub plan heals to 6 going down and 9 going up rather than
           to 4 and 10. Down through 0 removes the line, same as the x button. */
        var next = parseInt(step.getAttribute('data-tcd-step'), 10) > 0
          ? Math.floor(qty / pack) * pack + pack
          : Math.floor((qty - 1) / pack) * pack;
        if (!(next > 0)) { next = 0; }
        busy = true;
        cell.querySelectorAll('[data-tcd-step]').forEach(function (b) { b.disabled = true; });
        changeLine(cell.getAttribute('data-tcd-key'), next);
        return;
      }

      var opener = e.target.closest('[data-cart-drawer-open]');
      if (opener) { e.preventDefault(); open(); return; }

      var ritual = e.target.closest('#tlpAtc');
      if (ritual) {
        e.preventDefault();
        /* 2026-09-02 (Wander): FALLBACK ONLY. The live path is
           assets/tessera-cart-bridge.js, which stopPropagation()s the click so
           this branch never runs while that file is loaded. When it does run
           (cart-bridge failed to load) it now reads the selected card's
           data-qty and data-selling-plan, so it adds what the card promised.
           It used to hardcode quantity 1 with no plan - on the 90-Day card
           that was one tub at full price, and once plans were wired it would
           have been one tub on a three-tub plan, which is worse than nothing. */
        var sel = document.querySelector('#tlp .plan.sel');
        var vid = (sel && sel.getAttribute('data-variant')) || ritual.getAttribute('data-variant');
        var qty = (sel && parseInt(sel.getAttribute('data-qty'), 10)) || 1;
        var plan = sel ? sel.getAttribute('data-selling-plan') : null;
        if (vid) { addVariant(vid, qty, plan); } else { open(); }
      }
    });

    /* 2026-09-02 (Wander): sections/main-cart.liquid sets this flag just before
       it bounces a JS-enabled visitor off the retired /cart page. Cleared
       BEFORE open() so a reload of the page we landed on cannot re-open the
       drawer, and so a failure inside open() still consumes it. Nothing else
       reads the flag, and it lives in sessionStorage, so a drawer script that
       never runs leaves an inert value that dies with the tab or is consumed
       by the next working load. open() already calls refresh(), so this is
       one cart fetch either way, not two. */
    var autoOpen = false;
    try {
      if (sessionStorage.getItem('tcd-open-on-load')) {
        sessionStorage.removeItem('tcd-open-on-load');
        autoOpen = true;
      }
    } catch (e) {}

    if (autoOpen) { open(); } else { refresh(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"]) return;
  try {
    
(function(){
  var root = document.querySelector('.fq');
  if(!root) return;

  root.addEventListener('click', function(e){
    var btn = e.target.closest('.fq__qh');
    if(!btn) return;
    var card = btn.parentElement;
    var list = card.parentElement;
    var wasOpen = card.classList.contains('is-open');
    list.querySelectorAll('.fq__q').forEach(function(q){ q.classList.remove('is-open'); });
    if(!wasOpen) card.classList.add('is-open');
  });

  var chips  = Array.prototype.slice.call(root.querySelectorAll('.fq__chip'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('.fq__group'));

  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      var group = document.getElementById(chip.getAttribute('data-target'));
      if(!group) return;
      var firstQ = group.querySelector('.fq__q');
      var y = firstQ.getBoundingClientRect().top + window.scrollY - 104;
      window.scrollTo({ top:y, behavior:'smooth' });
    });
  });

  if('IntersectionObserver' in window){
    var spy = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        chips.forEach(function(c){ c.classList.toggle('is-active', c.getAttribute('data-target') === en.target.id); });
      });
    }, { rootMargin:'-15% 0px -70% 0px', threshold:0 });
    groups.forEach(function(g){ spy.observe(g); });

    var split = root.querySelector('.fq__group.is-split');
    if(split){
      split.querySelectorAll('.fq__q').forEach(function(c,i){ c.style.transitionDelay = (i*55)+'ms'; });
      var fan = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ split.classList.add('is-open2'); fan.unobserve(en.target); }
        });
      }, { rootMargin:'0px 0px -18% 0px', threshold:0 });
      fan.observe(split);
    }
  } else {
    var s = root.querySelector('.fq__group.is-split');
    if(s) s.classList.add('is-open2');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.tfaq__head');
  if (!btn) return;
  var card = btn.parentElement;
  var list = card.parentElement;
  var wasOpen = card.classList.contains('is-open');
  list.querySelectorAll('.tfaq__q').forEach(function (q) { q.classList.remove('is-open'); });
  if (!wasOpen) card.classList.add('is-open');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = data.item_count;
      });
    })
    .catch(function() {});

  var drawer   = document.getElementById('navDrawer');
  var overlay  = document.getElementById('navOverlay');
  var openBtn  = document.querySelector('.menu-btn');
  var closeBtn = document.getElementById('navDrawerClose');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    openBtn.focus();
  }

  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/* 2026-09-01 (Wander): line the collection heading up with the first header
   nav link ("Shop now"). Measured rather than hard-coded — the nav's left edge
   moves with the logo width, the webfont swap and the per-page nav gap. The
   stylesheet above paints a close estimate first, so this correction is a few
   pixels rather than a visible jump. Clearing the inline style falls back to
   that estimate; below 981px the estimate does not apply either, so the
   heading stays flush left. */
(function () {
  function align() {
    var head = document.querySelector('.t-coll__head');
    if (!head) return;
    head.style.marginLeft = '';                   /* back to the CSS estimate */
    var link = document.querySelector('.nav-links a');
    if (!link || !link.offsetParent) return;      /* nav hidden: leave the CSS estimate alone */
    /* THE ESTIMATE IS STILL APPLIED when the measurement is taken, so the gap
       measured here is the REMAINING error, not the whole indent. It has to be
       added to the estimate; using it on its own lands the heading at roughly
       the estimate's width instead of at the nav link. */
    var base = parseFloat(window.getComputedStyle(head).marginLeft) || 0;
    var target = base + (link.getBoundingClientRect().left - head.getBoundingClientRect().left);
    if (target > 0) head.style.marginLeft = Math.round(target) + 'px';
  }

  /* coalesce resizes to at most one measurement per frame */
  var queued = false;
  function onResize() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; align(); });
  }

  if (document.readyState !== 'loading') align();
  else document.addEventListener('DOMContentLoaded', align);
  window.addEventListener('resize', onResize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var main = document.getElementById('tPdpMain');
  document.querySelectorAll('.t-pdp__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) main.src = btn.getAttribute('data-full');
      document.querySelectorAll('.t-pdp__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  var qty = document.getElementById('tPdpQty');
  document.querySelectorAll('.t-pdp__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.getAttribute('data-step'), 10);
      var next = (parseInt(qty.value, 10) || 1) + step;
      qty.value = next < 1 ? 1 : next;
    });
  });

  /* 2026-09-02 (Wander): add to cart WITHOUT leaving the page.
     The product form tag renders <form action="/cart/add" method="post">, and a
     native POST there makes Shopify redirect to /cart - this was the last route
     on the site that still landed a shopper on the standalone cart page. The
     submit is intercepted here, posted to /cart/add.js instead, and the drawer
     is opened by clicking the hidden #tPdpDrawerOpener, which is exactly how
     assets/tessera-cart-bridge.js opens it from the daily page.
     The native form is deliberately left intact: if this script does not run,
     or fetch is missing, or the opener is absent, the handler returns WITHOUT
     preventDefault and the old POST-and-redirect still works. That is the
     correct no-JS degradation, not a bug.
     pdpBusy mirrors the busy flag in cart-bridge - the button is disabled in
     flight, but a keyboard Enter can submit a form without the button.
     NOTE this block must stay ABOVE the `if (!dataEl) return;` below: that
     early return fires on any product with only a default variant, which is
     every product in this store today. */
  var pdpForm   = document.getElementById('tPdpForm');
  var pdpAdd    = document.getElementById('tPdpAdd');
  var pdpOpener = document.getElementById('tPdpDrawerOpener');
  var pdpBusy   = false;
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      if (!window.fetch || !pdpOpener) { return; }
      var idEl  = document.getElementById('tPdpVariantId');
      var qtyEl = document.getElementById('tPdpQty');
      var vid   = idEl && idEl.value;
      if (!vid) { return; }
      e.preventDefault();
      if (pdpBusy) { return; }
      var n = parseInt(qtyEl && qtyEl.value, 10);
      if (!(n > 0)) { n = 1; }
      pdpBusy = true;
      if (pdpAdd) { pdpAdd.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: n }] })
      }).then(function (res) {
        pdpBusy = false;
        if (pdpAdd) { pdpAdd.disabled = false; }
        if (!res.ok) { return; }
        pdpOpener.click();
      }).catch(function () {
        pdpBusy = false;
        if (pdpAdd) { pdpAdd.disabled = false; }
      });
    });
  }

  var dataEl = document.getElementById('tPdpVariants');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);
  var selects  = Array.prototype.slice.call(document.querySelectorAll('.t-pdp__select'));
  var idInput  = document.getElementById('tPdpVariantId');
  var priceEl  = document.getElementById('tPdpPrice');
  var addBtn   = document.getElementById('tPdpAdd');
  var addText  = document.getElementById('tPdpAddText');

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
  }

  function update() {
    var chosen = selects.map(function (s) { return s.value; });
    var match = variants.find(function (variant) {
      return chosen.every(function (val, i) { return variant.options[i] === val; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (priceEl) {
      var html = '<span class="t-pdp__price-now">' + money(match.price) + '</span>';
      if (match.compare_at_price && match.compare_at_price > match.price) {
        html += '<s class="t-pdp__price-was">' + money(match.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    }
    if (addBtn) {
      addBtn.disabled = !match.available;
      if (!match.available) { addText.textContent = 'Sold out'; }
      else if (addText.textContent === 'Sold out') { addText.textContent = 'Add to cart'; }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tessera-contact"] && !Shopify.designMode) return;
  try {
    
/* Copy the contact address. navigator.clipboard needs a secure context and is
   missing from some in-app browsers, so the textarea fallback stays. */
(function () {
  function bind() {
    var btn = document.getElementById('ts-contact-copy');
    if (!btn || btn.dataset.bound) { return; }
    btn.dataset.bound = '1';
    var timer;

    function flash() {
      btn.classList.add('is-copied');
      clearTimeout(timer);
      timer = setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
    }

    function legacyCopy(text) {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.position = 'absolute';
      t.style.left = '-9999px';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t);
      flash();
    }

    btn.addEventListener('click', function () {
      var email = btn.getAttribute('data-email') || '';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(flash).catch(function () { legacyCopy(email); });
      } else {
        legacyCopy(email);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.testimonials-section');
  sections.forEach(function(section) {
    var track = section.querySelector('.t-track');
    var prev = section.querySelector('[id^="tPrev"]');
    var next = section.querySelector('[id^="tNext"]');
    if (!track || !prev || !next) return;
    var idx = 0;
    function cardWidth() {
      var card = track.querySelector('.t-card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || '22');
      return card.getBoundingClientRect().width + gap;
    }
    function visibleCount() {
      return Math.max(1, Math.round(track.parentElement.clientWidth / cardWidth()));
    }
    function maxIdx() {
      return Math.max(0, track.children.length - visibleCount());
    }
    function update() {
      idx = Math.max(0, Math.min(idx, maxIdx()));
      track.style.transform = 'translateX(' + (-idx * cardWidth()) + 'px)';
      prev.disabled = idx <= 0;
      next.disabled = idx >= maxIdx();
    }
    prev.addEventListener('click', function() { idx -= 1; update(); });
    next.addEventListener('click', function() { idx += 1; update(); });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
